import React, { useState } from 'react';
import { Container, Row, Col, Collapse, Button } from 'react-bootstrap';
import Footer from '../components/Footer'; // Import the Footer component

const Home = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Container className="mt-5">
        {/* Banner Image */}
        <Row>
          <Col>
            <img 
              src="/images/banner.jpg"  // Ensure this image exists in the public/images folder
              alt="Therapy and Car Accident Recovery"
              className="img-fluid w-100"
              style={{ height: '300px', objectFit: 'cover', borderRadius: '10px' }}
            />
          </Col>
        </Row>

        {/* Title and Introduction */}
        <Row className="text-center mt-4 mb-4">
          <Col>
            <h1 className="fw-bold text-dark display-4">Circle of Care & Wellness</h1>
            <p className="text-muted lead">
            Circle of Care and Wellness is a multidisciplinary circle of care health
            care team that uses evidence-based treatment for both physical and
            psychological impacts following a motor vehicle accident or trauma-
            induced injury.
            </p>
            <p className="text-muted lead">We offer the following services:</p>
            <ul className="list-unstyled">
              <li>Psychological counselling</li>
              <li>Social work</li>
              <li>In-home therapy</li>
              <li>Case management</li>
              <li>Physiotherapy and massage</li>
              <li>Social work assessment</li>
              <li>Driving anxiety therapy</li>
              <li>WSIB support</li>
            </ul>
          </Col>
        </Row>
        
        {/* Importance of Getting Help */}
        <Row className="mt-4">
          <Col>
            <h2 className="fw-bold text-dark">Why It’s Important to Get Help</h2>
            <p className="text-muted">
              It is vital to access support immediately after the accident, as physical and 
              emotional or psychological trauma may make you feel unsafe or helpless. Circle 
              of Care and Wellness provides professionals and expertise in the care you need, 
              using comprehensive, evidence-based treatment interventions for both physical 
              and emotional wellness.
            </p>
            <p className="text-muted">
              Our goal is to help you manage symptoms and regain control of your life, addressing 
              common challenges and overcoming physical or emotional barriers as we guide you on 
              your path to recovery and to optimal independence and well-being.
            </p>
          </Col>
        </Row>
        
        {/* Summary of Services with Dropdown */}
        <Row className="mt-4">
          <Col>
            <h2 className="fw-bold text-dark">Summary of Services</h2>
            <Button
              onClick={() => setOpen(!open)}
              aria-controls="summary-collapse"
              aria-expanded={open}
              variant="dark"
              className="mb-3"
            >
              {open ? "Hide Details" : "View Details"}
            </Button>
            <Collapse in={open}>
              <div id="summary-collapse">
                <Row className="mt-3">
                  <Col>
                    <h4 className="fw-bold text-dark">Psychological Counselling</h4>
                    <p className="text-muted">Motor vehicle accidents may lead to emotional and psychological trauma. Our psychological counselling services are designed to help you cope and recover.</p>
                    <ul>
                      <li>Acceptance and commitment therapy</li>
                      <li>Cognitive-behavioural therapy</li>
                      <li>Relaxation training</li>
                      <li>Chronic pain coping mechanisms</li>
                      <li>Mindfulness-based intervention</li>
                      <li>Humanistic-experiential therapy</li>
                    </ul>
                  </Col>
                </Row>
                
                <Row className="mt-4">
                  <Col>
                    <h4 className="fw-bold text-dark">Social Work</h4>
                    <p className="text-muted">Following a motor vehicle accident, a social worker delivers services crucial to rehabilitation within a multidisciplinary team.</p>
                    <ul>
                      <li>Conduct intake assessments</li>
                      <li>Provide crisis intervention</li>
                      <li>Assist in navigating community resources</li>
                      <li>Monitor third-party administered therapy</li>
                    </ul>
                  </Col> 
                </Row>
                
                <Row className="mt-4">
                  <Col>
                    <h4 className="fw-bold text-dark">Driving Anxiety Therapy</h4>
                    <p className="text-muted">Fear of driving, known as vehophobia, can limit your ability to travel. Our therapy helps reduce anxiety and build confidence in driving.</p>
                    <ul>
                      <li>Cognitive Behavioural Therapy (CBT)</li>
                      <li>Exposure Therapy</li>
                      <li>Managing PTSD-related driving fears</li>
                    </ul>
                  </Col>
                </Row>
                
                <Row className="mt-4">
                  <Col>
                    <h4 className="fw-bold text-dark">Extended Health Plans & Insurance Coverage</h4>
                    <p className="text-muted">We accept refugees, immigrants, and newcomers through the Interim Federal Health Program (IFHP), as well as WSIB mental health support for work-related injuries.</p>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </Col>
        </Row>
      </Container>

      {/* Footer Section */}
      <Footer />
    </>
  );
};

export default Home;
